import { render, staticRenderFns } from "./back-btn.vue?vue&type=template&id=76571322&scoped=true&"
import script from "./back-btn.vue?vue&type=script&lang=js&"
export * from "./back-btn.vue?vue&type=script&lang=js&"
import style0 from "./back-btn.vue?vue&type=style&index=0&id=76571322&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76571322",
  null
  
)

export default component.exports